<template>
  <div>
    <iframe
      v-if="selectPlugin != null && !isNewRegistrationMethod"
      id="show-plugin"
      ref="iframeSystemSettings"
      style="width: 100%; height: 100%"
      frameBorder="0"
    ></iframe>
    <component v-if="isNewRegistrationMethod" :key="pluginInfo.plugin_id" :is="currentcomponent"></component>
  </div>
</template>


<script>
import { mapMutations,mapGetters } from "vuex";
import Utils from "../../components.utils.js"
export default {
  data() {
    return {
      seletedPlugin: null,
      iframeController: null,
      registeredNotifications:[],
      currentcomponent:null,
      isNewRegistrationMethod:false,
    };
  },
  watch: {
    pluginInfo(ol, nl) {
      if (ol != nl) {
        if(this.isNewRegistrationType()){  
          this.loadPlugin(ol.id);
        }else{  
          this.isNewRegistrationMethod = false;
          setTimeout(() => this.selectPlugin(this.pluginInfo.pluginName), 100);
        }
      }  
    },
  },
  methods: {
    async loadPlugin(){
      // let plugin =  this.getRegisteredPluginMapper()[id];
      let plugin = this.pluginInfo;
      console.log("Plugin......",plugin);
      if(plugin && Object.prototype.hasOwnProperty.call(plugin,"importExporttabsLoadingInfo")){
          this.seletedPlugin = this.pluginInfo.plugin_name;
          this.isNewRegistrationMethod = true;
          let compInfo = await  Utils.loadPluginBundles([plugin.importExporttabsLoadingInfo.pluginBundle.js],plugin.importExporttabsLoadingInfo.eventName);
          Utils.loadCssBundle(plugin.importExporttabsLoadingInfo.pluginBundle.css);
          console.log("compInfo compInfo",compInfo);
          if(compInfo[0] && compInfo[0].pluginStore && Array.isArray(compInfo[0].pluginStore) && compInfo[0].pluginStore.length){
              for(let i = 0; i < compInfo[0].pluginStore.length; i++){
                if(!this.$store.hasModule(compInfo[0].pluginStore[i].module))
                  this.$store.registerModule(compInfo[0].pluginStore[i].module,compInfo[0].pluginStore[i].store); // registers store dynamically at run time
              }
          }else{
            if(compInfo[0] && compInfo[0].pluginStore && !this.$store.hasModule(compInfo[0].pluginStore.module))
                this.$store.registerModule(compInfo[0].pluginStore.module,compInfo[0].pluginStore.store); // registers store dynamically at run time
          }

          this.$nextTick(()=>{
                this.currentcomponent = compInfo[0].components;
          });
      }
    },

    isNewRegistrationType(){
      let plugin =  this.pluginInfo;
      console.log("Plugin......",plugin);
      if(plugin && Object.prototype.hasOwnProperty.call(plugin,"importExporttabsLoadingInfo")){
        return true;
      }  
      return false;
    },


    selectPlugin(plugin) {
      this.seletedPlugin = plugin;
      this.loadExternalPluginForImportExportSettingsMenu({
        id: this.pluginInfo.id,
        pluginName: this.seletedPlugin,
        tagId: "show-plugin",
      });
      this.iframeController = this.$refs.iframeSystemSettings.contentWindow;
    },
    damNotificationCallback(notification) {
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      this.iframeController.postMessage(
        {
          cmd: "damNotification",
          params: Object.assign({}, notification),
        },
        "*"
      );
    },
    damLocalVariableChangeCallback(notification) {
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      this.iframeController.postMessage(
        {
          cmd: "damLocalVariableChangeNotification",
          params: Object.assign({}, notification),
        },
        "*"
      );
    },
    listenMessagesFromChild() {
      window.addEventListener("message", (event) => {
        let cmd = event.data.cmd;
        switch (cmd) {
          case "readyToListenMessage": {
            break;
          }
          case "damNotification": {
            let event_name = event.data.params.event_name;
            this.registeredNotifications.push({
                            eventname: event_name,
                            callback: this.damNotificationCallback,
                            parent:"ImportExportSettingsPlugin"
                          })
            this.addWSEventListener({
              eventname: event_name,
              callback: this.damNotificationCallback,
              parent:"ImportExportSettingsPlugin"
            });
            break;
          }
          default:
            break;
        }
      });
    },
    ...mapMutations("registry", [
      "loadExternalPluginForImportExportSettingsMenu",
    ]),
    ...mapGetters("registry",["getRegisteredPluginMapper"]),
    ...mapMutations("websocket", ["addWSEventListener", "removeWSEventListener"]),
  },
  props: ["pluginInfo"],
  created() {
    this.listenMessagesFromChild();
    window.addEventListener("supportbundle_localstorage_change",(event)=>{
        this.damLocalVariableChangeCallback(event)
    })
  },
  beforeDestroy(){
      for (const regnotification of this.registeredNotifications) {
        this.removeWSEventListener(regnotification)
      }
  },
  mounted() {
    if(this.pluginInfo && this.isNewRegistrationType()){  
      this.loadPlugin(this.pluginInfo.id);
    }else{
      setTimeout(() => this.selectPlugin(this.pluginInfo.pluginName), 100);
    }
    
     
  },
};
</script>


<style lang="scss" scoped>
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$active-blue: #007bff;

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-color;
  letter-spacing: normal;
  margin-top: 60px;
  background: $body-bg-color !important;
  font-size: 14px !important;
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
  cursor: pointer;
  overflow: hidden;
}

body {
  background: $body-bg-color !important;
  color: $text-color;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-color;
  letter-spacing: normal;
  margin-top: 60px;
  background: $body-bg-color !important;
  height: 100%;
  font-size: 14px !important;
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
  cursor: pointer;
  overflow: hidden;
}

html {
  overflow: auto;
}

select option {
  margin: 40px;
  background: #000;
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}
</style>


